import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WarrantyComponent } from './warranty.component';
import { RouterModule, Routes } from '@angular/router';
import { CoreModule } from '@app/core/core.module';
import { HeroModule } from '@app/core/components/hero/hero.module';
import { InfoBlockModule } from '@app/core/components/info-block/info-block.module';
import { TranslateModule } from '@ngx-translate/core';
import { HelpOptionsModule } from '../../core/components/help-options/help-options.module';
import { FlyerSaldoModule } from '../../landing-social-proof/components/flyer-saldo/flyer-saldo.module';
const routes: Routes = [
    {
        path: '',
        component: WarrantyComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    declarations: []
})
export class WarrantyRoutingModule {}

@NgModule({
    declarations: [WarrantyComponent],
    imports: [
        CommonModule,
        WarrantyRoutingModule,
        HeroModule,
        CoreModule,
        InfoBlockModule,
        TranslateModule,
        HelpOptionsModule,
        FlyerSaldoModule
    ]
})
export class WarrantyModule {}
